import { render, staticRenderFns } from "./LeakInvestigationReportsTable.vue?vue&type=template&id=1d7271e2&scoped=true"
import script from "./LeakInvestigationReportsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LeakInvestigationReportsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LeakInvestigationReportsTable.vue?vue&type=style&index=0&id=1d7271e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7271e2",
  null
  
)

export default component.exports